import { Recycle, Trash2, RefreshCw, Leaf } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import ServicePageLayout from '../components/ServicePageLayout'
import SEO from '../components/SEO'
import { serviceSEOData } from '../utils/serviceSEO'

// ✅ Import images to ensure they work in production
import hero1 from '../assets/Services/recycling/hero-1.jpg'
import hero2 from '../assets/Services/recycling/hero-2.jpg'
import hero3 from '../assets/Services/recycling/hero-3.jpg'
import resourceImg from '../assets/Services/recycling/Resource-Conservation.avif'
import wasteImg from '../assets/Services/recycling/Waste-Reduction.jpeg'
import energyImg from '../assets/Services/recycling/Energy-Savings.avif'
import envImg from '../assets/Services/recycling/Environmental-Protection.jpeg'

const Recycling = () => {
  const { t } = useTranslation()
  
  const service = {
    heroSlides: [
      {
        image: hero1, // ✅ Use the imported variable
        title: t('recycling.heroSlides.0.title'),
        subtitle: t('recycling.heroSlides.0.subtitle'),
        description: t('recycling.heroSlides.0.description')
      },
      {
        image: hero2,
        title: t('recycling.heroSlides.1.title'),
        subtitle: t('recycling.heroSlides.1.subtitle'),
        description: t('recycling.heroSlides.1.description')
      },
      {
        image: hero3,
        title: t('recycling.heroSlides.2.title'),
        subtitle: t('recycling.heroSlides.2.subtitle'),
        description: t('recycling.heroSlides.2.description')
      }
    ],
    introText: t('recycling.introText'),
    stats: [
      { value: t('recycling.stats.hundred'), label: t('recycling.stats.ecoFriendly') },
      { value: t('recycling.stats.zero'), label: t('recycling.stats.wasteGoal') },
      { value: t('recycling.stats.twentyFourSeven'), label: t('recycling.stats.service') },
      { value: t('recycling.stats.green'), label: t('recycling.stats.future') }
    ],
    capabilities: t('recycling.capabilities', { returnObjects: true }),
    services: [
      {
        icon: Recycle,
        title: t('recycling.services.resourceConservation.title'),
        description: t('recycling.services.resourceConservation.description'),
        image: resourceImg // ✅ Use the imported variable
      },
      {
        icon: Trash2,
        title: t('recycling.services.wasteReduction.title'),
        description: t('recycling.services.wasteReduction.description'),
        image: wasteImg
      },
      {
        icon: RefreshCw,
        title: t('recycling.services.energySavings.title'),
        description: t('recycling.services.energySavings.description'),
        image: energyImg
      },
      {
        icon: Leaf,
        title: t('recycling.services.environmentalProtection.title'),
        description: t('recycling.services.environmentalProtection.description'),
        image: envImg
      }
    ],
    workflow: [
      {
        step: t('recycling.workflow.0.step'),
        title: t('recycling.workflow.0.title'),
        description: t('recycling.workflow.0.description')
      },
      {
        step: t('recycling.workflow.1.step'),
        title: t('recycling.workflow.1.title'),
        description: t('recycling.workflow.1.description')
      },
      {
        step: t('recycling.workflow.2.step'),
        title: t('recycling.workflow.2.title'),
        description: t('recycling.workflow.2.description')
      },
      {
        step: t('recycling.workflow.3.step'),
        title: t('recycling.workflow.3.title'),
        description: t('recycling.workflow.3.description')
      }
    ]
  }

  return (
    <>
      <SEO {...serviceSEOData['recycling']} url="/services/recycling" />
      <ServicePageLayout
      title={service.heroSlides[0].title}
      subtitle={service.heroSlides[0].subtitle}
      description={service.heroSlides[0].description}
      backgroundImages={service.heroSlides.map(slide => slide.image)}
      heroSlides={service.heroSlides}
      introText={service.introText}
      capabilities={service.capabilities}
      services={service.services}
      stats={service.stats}
      workflow={service.workflow}
      />
    </>
  )
}

export default Recycling